import type { Admin } from "./types"

export const PERMISSIONS = {
  MANAGE_USERS: "manage_users",
  EDIT_DOCS: "edit_docs",
  PUBLISH_DOCS: "publish_docs",
  MANAGE_QUIZZES: "manage_quizzes",
} as const

export function hasPermission(admin: Admin | null | undefined, key: string): boolean {
  if (!admin) return false
  if (admin.role === "super_admin") return true
  return admin.permissions?.includes(key) ?? false
}
